export const UPDATE_HELPER_TYPE = 'UPDATE_HELPER_TYPE';

export const updateHelperType = (helperType) => ({
  type: UPDATE_HELPER_TYPE,
  payload: helperType
});
